module.exports = __webpack_public_path__ + "static/media/ethereum-gold.4bea2bdd.svg";